module.exports = __webpack_public_path__ + "img/3-6614.a98880d3.png";